import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'MarkdownContent' })((theme) => ({
    root: {
        '& h2': {
            fontSize: 18,
            marginBottom: 16,
            fontWeight: 600,
            lineHeight: '150%',
            letterSpacing: '-0.36px',
            scrollMarginTop: 90
        },
        '& p': {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: '150%',
            letterSpacing: '-0.28px',
            marginBottom: 48
        },
        '& a': {
            color: theme.palette.primary.main,
            textDecoration: 'underline',
            '&:hover': {
                textDecoration: 'underline'
            }
        }
    }
}));
